import React from 'react';
import PropTypes from 'prop-types';
// import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import LightBoxPhotoList from './LightBoxPhotoList';
// import { colors } from '../../styles';

const styles = css`
  .PhotoList {
    padding: 20px 0 30px;
    position: relative;
    @media(min-width: 992px) {
      padding: 20px 0 60px;
    }
  }

`;
function PhotoList({ photos }) {
  return (
    <div className={styles} id="gallery">
      <div className="PhotoList">
        <div className="container">
          <LightBoxPhotoList
            show={8}
            photos={photos}
          />
        </div>
      </div>
    </div>
  );
}

PhotoList.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PhotoList;



// WEBPACK FOOTER //
// ./src/components/PhotoList.js